import React from "react";
import { useEffect, useState } from "react";
import Header from "../../component/header/Header";
import Footer_menu from "../../component/footer_menu";
import alertStyle from "./Ads_alert.module.css";
import appURLs from "../../appURL";
import getFetchConfig from "../../utils/getFetchConfig";
import { toast } from "react-toastify";

function Ads_alert() {
  const fetchConfig = getFetchConfig();
  const appURL = appURLs();

  const [getAlert, setGetAlert] = useState([]);
  const [toggleStatus, setToggleStatus] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [togglingId, setTogglingId] = useState(null); // Track which toggle is being updated

  const getAdsAlert = async () => {
    setLoading(true); // Set loading true before API call
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await fetch(`${appURL}/posts/ads/get-alerts`, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      

      const initialToggleStatus = {};
      jsonData.notification.forEach((item) => {
        initialToggleStatus[item.category] = item.value;
      });
      setToggleStatus(initialToggleStatus);

      setGetAlert(jsonData.notification);

      
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load alerts");
    } finally {
      setLoading(false); // Set loading false after API call completes
    }
  };

  const toggleAlert = async (add_name, notification_status) => {
    setTogglingId(add_name); // Set toggling ID
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const body = JSON.stringify({ add_name, notification_status });

      const response = await fetch(`${appURL}/posts/ads/create-alert`, {
        ...fetchConfig,
        method: "POST",
        headers: headers,
        body: body,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setToggleStatus({ ...toggleStatus, [add_name]: notification_status });

      if (notification_status) {
        toast.success(`${add_name} is On`);
      } else {
        toast.error(`${add_name} is Off`);
      }

      
    } catch (error) {
      console.error("Error toggling alert:", error);
      toast.error(`Failed to toggle ${add_name}`);
    } finally {
      setTogglingId(null); // Clear toggling ID
    }
  };

  useEffect(() => {
    getAdsAlert();
  }, []);

  // Loading skeleton component
  const LoadingSkeleton = () => (
    <>
      {[1, 2, 3, 4, 5].map((item) => (
        <li key={item} className={alertStyle.loading_skeleton}>
          <div className={alertStyle.skeleton_content}>
            <div className={alertStyle.skeleton_text}></div>
            <div className={alertStyle.skeleton_toggle}></div>
          </div>
        </li>
      ))}
    </>
  );

  return (
    <div>
      {/* <Header /> */}

      {/* alert Content start from here */}
      <div className={alertStyle.min_alert}>
        <div className={alertStyle.main_alert}>
          <h1>Ads Alert</h1>

          <ul>
            {loading ? (
              <LoadingSkeleton />
            ) : getAlert.length > 0 ? (
              getAlert.map((item, index) => (
                <li className={alertStyle.button_toggle_detail} key={index}>
                  {item.category}

                  <div className={alertStyle.toggle_switch_button}>
                    <input
                      type="checkbox"
                      id={`switch-${index}`}
                      checked={toggleStatus[item.category] || false}
                      onChange={() => {
                        const newStatus = !toggleStatus[item.category];
                        setToggleStatus({
                          ...toggleStatus,
                          [item.category]: newStatus,
                        });
                        toggleAlert(item.category, newStatus);
                      }}
                      disabled={togglingId === item.category} // Disable while toggling
                    />
                    <label 
                      htmlFor={`switch-${index}`}
                      className={togglingId === item.category ? alertStyle.toggling : ''}
                    >
                      Toggle
                    </label>
                    {togglingId === item.category && (
                      <span className={alertStyle.toggle_loader}></span>
                    )}
                  </div>
                </li>
              ))
            ) : (
              <li className={alertStyle.empty_state}>
                <p>No alerts found</p>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Ads_alert;